/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

function RecentlyEditedJourney({ localizations, ...props }) {
  return (
    <li className="slds-item">
      <div className="slds-tile">
        <h3 className="slds-truncate">
          <a href={props.url} onClick={props.onClick}>
            {props.name}
          </a>
        </h3>
        <div className="slds-tile__detail slds-text-body--small">
          <p className="slds-text-color--weak">
            <FormattedMessage
              id="homepage.cards.journey_edited_on"
              values={{
                edit_date: props.modifiedDate,
                edit_time: props.modifiedDate,
              }}
            />
          </p>
          <p className="slds-m-bottom--x-small slds-truncate">{props.description}</p>
          <div className="slds-grid slds-wrap">
            <div
              className="slds-col slds-size--1-of-4 slds-text-color--weak slds-truncate"
              title={localizations['homepage.cards.status']}
            >
              {localizations['homepage.cards.status']}
            </div>
            <div className="slds-col slds-size--3-of-4 slds-truncate">{props.status}</div>
          </div>
        </div>
      </div>
    </li>
  );
}

RecentlyEditedJourney.displayName = 'Recently Edited Journey';

RecentlyEditedJourney.propTypes = {
  description: PropTypes.string,
  localizations: PropTypes.object,
  modifiedDate: PropTypes.number,
  name: PropTypes.string,
  onClick: PropTypes.func,
  status: PropTypes.string,
  url: PropTypes.string,
};

RecentlyEditedJourney.defaultProps = {
  url: 'javascript:void(0);', // eslint-disable-line no-script-url
};

export default RecentlyEditedJourney;
